import AppDownloadCTA from "./AppDownloadCTA";

interface Props {
  source?: string;
}

// Broker-aware CTA: reframes the app as the natural next step after
// picking a broker — reduces CTA dissonance on comparison posts.
const AppBridgeCTA = ({ source = "blog-broker" }: Props) => {
  return (
    <aside className="my-10 rounded-2xl border-2 border-primary/30 bg-gradient-to-br from-primary/5 via-background to-primary/10 p-6 md:p-8">
      <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">
        Already picked a broker?
      </p>
      <p role="heading" aria-level={2} className="text-xl md:text-2xl font-bold text-foreground mb-3">
        Track every position, dividend, and fee across all of them in PieFolio AI.
      </p>
      <p className="text-foreground/70 mb-5 leading-relaxed">
        One Portfolio Health score, one dividend calendar, AI-written analysis on
        top of your actual holdings — no matter how many brokers you use.
      </p>
      <AppDownloadCTA variant="compact" source={source} />
    </aside>
  );
};

export default AppBridgeCTA;
